'use client';

import { useAppDispatch, useAppSelector } from '@repo/store/maps/hooks';
import { type LayerVisibility, MAP_LAYERS, selectMapData, setLayerVisibility } from '@repo/store/maps/slices/mapData';
import { useCallback, useEffect, useRef } from 'react';
export function useLayerUrlInitializer() {
  const dispatch = useAppDispatch();
  const mapData = useAppSelector(selectMapData);
  const appliedRef = useRef(false);
  const parseLayersFromUrl = useCallback(() => {
    if (typeof window === 'undefined') return null;
    try {
      const url = new URL(window.location.href);
      const layersParam = url.searchParams.get('layers');
      if (!layersParam) return null;
      const requestedLayers = layersParam.split(',').filter(Boolean);
      const visibility: LayerVisibility = {
        rasterTiles: false,
        labels: false,
        regions: false,
        objects3d: false,
        fogOfWar: false
      };
      for (const name of requestedLayers) {
        const key = MAP_LAYERS[name.toLowerCase()];
        if (key) {
          visibility[key] = true;
        }
      }
      return visibility;
    } catch {
      return null;
    }
  }, []);
  const cleanUpLayerUrlParam = useCallback(() => {
    if (typeof window === 'undefined') return;
    const url_0 = new URL(window.location.href);
    url_0.searchParams.delete('layers');
    window.history.replaceState({}, '', url_0.toString());
  }, []);
  useEffect(() => {
    if (!mapData || appliedRef.current) return;
    const visibility_0 = parseLayersFromUrl();
    if (visibility_0) {
      dispatch(setLayerVisibility(visibility_0));
      cleanUpLayerUrlParam();
      appliedRef.current = true;
    }
  }, [dispatch, parseLayersFromUrl, cleanUpLayerUrlParam, mapData]);
}